import { render } from "./QuickpayDownloadDocument.vue?vue&type=template&id=aa9fa13a&scoped=true"
import script from "./QuickpayDownloadDocument.vue?vue&type=script&lang=js"
export * from "./QuickpayDownloadDocument.vue?vue&type=script&lang=js"

import "./QuickpayDownloadDocument.vue?vue&type=style&index=0&id=aa9fa13a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9fa13a"]])

export default __exports__